module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("content_gallery_fullscreen_view", [["div",{"class":"gallery-input"},[["i",{"class":"icon-gift"}],["textNode",{"text":" "}],["input",{"id":"tip-amount","type":"text","placeholder":"$2"}]]],["button",{"id":"tip-model","class":"gallery-btn filled tipme"},[["textNode",{"text":"tip"}]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/templates/sitepage/gallery/tipme.tpl
// module id = 785
// module chunks = 4